const btnTableTileMatOverrides = {
  export: 'Exportar datos',
  addRowLabel: 'agregar',
  options: 'opciones',
  exportChecklist: 'Exportar checklist',
  import: 'Importar',
  importData: 'Importar datos',
};

export default btnTableTileMatOverrides;
